// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-SupportTools-styles___bulkCategoryUploadCard--xJLFq {
  position: relative;
  margin: 16px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
  .components-SupportTools-styles___bulkCategoryUploadCard--xJLFq .components-SupportTools-styles___header--K4f2s {
    padding: 8px 16px;
  }
  .components-SupportTools-styles___bulkCategoryUploadCard--xJLFq .components-SupportTools-styles___description--zTrh2 {
    margin-bottom: 16px;
  }
  .components-SupportTools-styles___bulkCategoryUploadCard--xJLFq .components-SupportTools-styles___fileInput--otEui {
    margin: 16px 0;
  }
  .components-SupportTools-styles___bulkCategoryUploadCard--xJLFq .components-SupportTools-styles___checkboxWithTooltip--yhRkD {
    display: flex;
    align-items: center;
  }
  .components-SupportTools-styles___bulkCategoryUploadCard--xJLFq .components-SupportTools-styles___tooltipIcon--_XlrG {
    margin-left: 8px;
    color: rgba(0, 0, 0, 0.54);
  }
  .components-SupportTools-styles___bulkCategoryUploadCard--xJLFq .components-SupportTools-styles___buttonContainer--eZqME {
    display: flex;
    justify-content: center;
    margin-top: 32px;
  }
  .components-SupportTools-styles___bulkCategoryUploadCard--xJLFq .components-SupportTools-styles___button--WGP1x {
    width: 200px;
  }
  .components-SupportTools-styles___bulkCategoryUploadCard--xJLFq .components-SupportTools-styles___infoLoader--yB_Q4 {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    right: 0;
  }


.components-SupportTools-styles___bulkCustomFieldOptionsUploadCard--CKKzs {
  margin: 16px;
  padding: 16px;
}


.components-SupportTools-styles___bulkCustomFieldOptionsUploadCard--CKKzs tbody tr {
      display: flex;
    }


.components-SupportTools-styles___bulkCustomFieldOptionsUploadCard--CKKzs tbody tr td {
        flex: 1;
      }


.components-SupportTools-styles___bulkCustomFieldOptionsUploadCard--CKKzs tbody tr :last-child {
        display: flex;
        justify-content: flex-end;
      }`, "",{"version":3,"sources":["webpack://./components/SupportTools/styles.pcss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wCAAwC;AA2C1C;EA1CE;IACE,iBAAiB;EACnB;EAEA;IACE,mBAAmB;EACrB;EAEA;IACE,cAAc;EAChB;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;EAEA;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,gBAAgB;EAClB;EAEA;IACE,YAAY;EACd;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,MAAM;IACN,QAAQ;EACV;;;AAIF;EACE,YAAY;EACZ,aAAa;AAaf;;;AAXI;MACE,aAAa;IAQf;;;AAPE;QACE,OAAO;MACT;;;AACA;QACE,aAAa;QACb,yBAAyB;MAC3B","sourcesContent":[".bulkCategoryUploadCard {\n  position: relative;\n  margin: 16px;\n  padding: 16px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  .header {\n    padding: 8px 16px;\n  }\n\n  .description {\n    margin-bottom: 16px;\n  }\n\n  .fileInput {\n    margin: 16px 0;\n  }\n\n  .checkboxWithTooltip {\n    display: flex;\n    align-items: center;\n  }\n\n  .tooltipIcon {\n    margin-left: 8px;\n    color: rgba(0, 0, 0, 0.54);\n  }\n\n  .buttonContainer {\n    display: flex;\n    justify-content: center;\n    margin-top: 32px;\n  }\n\n  .button {\n    width: 200px;\n  }\n\n  .infoLoader {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    top: 0;\n    right: 0;\n  }\n}\n\n\n.bulkCustomFieldOptionsUploadCard {\n  margin: 16px;\n  padding: 16px;\n  tbody {\n    tr {\n      display: flex;\n      td {\n        flex: 1;\n      }\n      :last-child {\n        display: flex;\n        justify-content: flex-end;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bulkCategoryUploadCard": `components-SupportTools-styles___bulkCategoryUploadCard--xJLFq`,
	"header": `components-SupportTools-styles___header--K4f2s`,
	"description": `components-SupportTools-styles___description--zTrh2`,
	"fileInput": `components-SupportTools-styles___fileInput--otEui`,
	"checkboxWithTooltip": `components-SupportTools-styles___checkboxWithTooltip--yhRkD`,
	"tooltipIcon": `components-SupportTools-styles___tooltipIcon--_XlrG`,
	"buttonContainer": `components-SupportTools-styles___buttonContainer--eZqME`,
	"button": `components-SupportTools-styles___button--WGP1x`,
	"infoLoader": `components-SupportTools-styles___infoLoader--yB_Q4`,
	"bulkCustomFieldOptionsUploadCard": `components-SupportTools-styles___bulkCustomFieldOptionsUploadCard--CKKzs`
};
module.exports = ___CSS_LOADER_EXPORT___;
